/* eslint-disable */

import { useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import FullPagePopupLayout from './FullPagePopupLayout'

const SIPPopups = () => {
  const { isOpen, onClose, type, data } = useModal()
  const navigate = useNavigate()

  const isModalOpen = isOpen && type === 'openSIPPopup'

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity || 'notice'}
      title={data?.title || 'SIP update'}
      message={data?.message}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={() => {
              onClose()
            }}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={() => {
              onClose(), navigate('/dashboard/plans')
            }}
          >
            Explore Goals
          </button>
        </>
      }
    />
  )
}

export default SIPPopups
